export default {
  title: 'Historial de lotes de QR Codes',
  name: 'Nombre',
  qrcodes: 'QR Codes',
  date: 'Fecha',
  pdf: 'PDF'
}
